import type {
  PageTypePageRequest,
  PageTypePageResponse,
} from '@shared/types/httpTypes/activityLibrary/community/bury_point/page_post';
import type {
  PageTypeEventRequest,
  PageTypeEventResponse,
} from '@shared/types/httpTypes/activityLibrary/community/bury_point/event_post';

import type { CommonInGroupIdsResponse } from '@shared/types/httpTypes/activityLibrary/cmt/common/inGroupIds_get';
import type {
  RelationDetailRequest,
  RelationDetailResponse,
} from '@shared/types/httpTypes/activityLibrary/home/privacy/agreement/relation';
import { API_PREFIX } from '@shared/config';
import { httpClient } from '@shared/utils';

/**
 * 页面埋点接口
 * @param pageType string
 * @param data PageTypePageRequest
 * @returns Promise<PageTypePageResponse>
 */
export const doBuryPagePoint = async (pageType: string, data: Partial<PageTypePageRequest>) => {
  return await httpClient.post<any, Required<PageTypePageResponse>>(
    `${API_PREFIX}api/community/bury_point/${pageType}/page`,
    data,
    {
      headers: {
        isHideError: true,
      },
    }
  );
};

/**
 * 事件埋点接口
 * @param pageType string
 * @param data PageTypeEventRequest
 * @returns Promise<PageTypeEventResponse>
 */
export const doBuryPageEventPoint = async (pageType: string, data: Partial<PageTypeEventRequest>) => {
  return await httpClient.post<any, Required<PageTypeEventResponse>>(
    `${API_PREFIX}api/community/bury_point/${pageType}/event`,
    data,
    {
      headers: {
        isHideError: true,
      },
    }
  );
};

/**
 * 获取用户所在群id
 * @returns Promise<ChatDetailResponse>
 */
export const getInGroupIds = async () => {
  return await httpClient.get<any, Required<CommonInGroupIdsResponse>>(`${API_PREFIX}api/cmt/common/inGroupIds`);
};

/**
 * 查询业务是否关联了隐私协议
 * @param objId string
 * @param type string
 * @returns RelationDetailResponse
 */
export const getActivityProtocolByBizId = async (data: RelationDetailRequest) => {
  return await httpClient.post<any, RelationDetailResponse>(
    `/caizhi_miniapi/home/privacy/agreement/relation/detail`,
    data
  );
};
